import axios from 'axios'
import router from '../../router'

const state = {
  backordInfoObj: '',
  clientStockInfoObj: '',
  salesOrderInfoObj: ''
}

const getters = {
  getBackOrdInfo(state){
    return state.backordInfoObj
  },
  getClientStockInfo(state){
    return state.clientStockInfoObj
  },
  getSalesOrderInfoObj(state){
    return state.salesOrderInfoObj
  }
}

const mutations = {
  setBackOrdInfo(state, payload){
    state.backordInfoObj = payload 
  },
  setClientStockInfo(state, payload){
    state.clientStockInfoObj = payload 
  },
  setSalesOrderInfoObj(state, payload){
    state.salesOrderInfoObj = payload 
  }
}

const actions = {
  apiBackOrderInfo (context, payload) {
    return new Promise((resolve, reject) => {
    axios.post('/api/backOrd', payload)
        .then((response) => {
            // console.log(response.data);
            context.commit('setBackOrdInfo', response.data)
            resolve()
        })
        .catch((error) => {
        if (error.response.status === 410) {
            alert('세션이 만료되어 로그인 페이지로 이동합니다.')
            sessionStorage.clear()
            router.replace('/')
        }else{
            reject(error)
        }
        })
    })
  },
  apiClientStockInfo (context, payload) {
    return new Promise((resolve, reject) => {
    axios.post('/api/getStcItem', payload)
        .then((response) => {
            //console.log(response);
            context.commit('setClientStockInfo', response.data)
            resolve()
        })
        .catch((error) => {
        if (error.response.status === 410) {
            alert('세션이 만료되어 로그인 페이지로 이동합니다.')
            sessionStorage.clear()
            router.replace('/')
        }else{
            reject(error)
        }
        })
    })
  },
  apiSalesOrderInfoObj (context, payload) {
    return new Promise((resolve, reject) => {
    axios.post('/api/salesOrder', payload)
        .then((response) => {
            //console.log(response);
            context.commit('setSalesOrderInfoObj', response.data)
            resolve()
        })
        .catch((error) => {
        if (error.response.status === 410) {
            alert('세션이 만료되어 로그인 페이지로 이동합니다.')
            sessionStorage.clear()
            router.replace('/')
        }else{
            reject(error)
        }
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
